/* unplugin-vue-components disabled */import { render } from "./VendorManage.vue?vue&type=template&id=83711d80&scoped=true"
import script from "./VendorManage.vue?vue&type=script&lang=js"
export * from "./VendorManage.vue?vue&type=script&lang=js"

import "./VendorManage.vue?vue&type=style&index=0&id=83711d80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83711d80"]])

export default __exports__